<template>
    <div>
        <v-autocomplete
                :reverse="reverse"
                v-model="model"
                :items="data"
                :label="label"
                :loading="loading"
                :search-input.sync="search"
                :full-width="true"
                cache-items
                clearable
                item-value="id"
                item-text="name"
                :multiple="multi"
                :rules="rules"
                :outline="outline"
                color="primary"
                :placeholder="placeholder || $t('inputs.shared.startTypingToSearch')"
                :return-object="returnObject"
                prepend-icon="fa fa-map-marker"
                :append-icon="append_icon"
        >
            <template
                    slot="selection"
                    slot-scope="data"
            >
                <v-chip
                        :selected="data.selected"
                        close
                        class="chip--select-multi"
                        @input="remove(data.item.id)"
                >
                    {{ data.item.name }}
                </v-chip>
            </template>
            <template
                    slot="item"
                    slot-scope="data"
            >
                <v-list-tile-content>
                    <v-list-tile-title
                            v-html="data.item.name"></v-list-tile-title>
                </v-list-tile-content>
            </template>
            <v-slide-x-reverse-transition
                    slot="append-outer"
                    mode="out-in"
            >
                <v-icon
                        :key="`icon-${isEditing}`"
                        :color="isEditing ? 'success' : 'info'"
                        @click="isEditing = !isEditing"
                        v-text="isEditing ? 'mdi-check-outline' : 'mdi-circle-edit-outline'"
                ></v-icon>
            </v-slide-x-reverse-transition>
        </v-autocomplete>
    </div>
</template>

<script>
    export default {
        name: "choose-location-multi",
        props: {
            append_icon: {
                type: String,
                default: 'fa fa-caret-down'
            },
            reverse: {
                default: false,
                type: Boolean
            },
            label: {},
            value: {},
            url: {
                type: String,
                default() {
                    return this.api.ACTIONS.LOCATIONS
                }
            },
            initialSearchParams: {
                type: URLSearchParams,
                default: () => new URLSearchParams()
            },
            multi: {
                type: Boolean,
                default: true
            },
            returnObject: {
                type: Boolean,
                default: false
            },
            outline: {
                type: Boolean,
                default: false
            },
            placeholder: {
                type: String,
                default: null
            },
            rules: {
                type: Array,
                default: () => []
            }
        },
        mounted() {
            if (this.returnObject && !!this.value) {
                this.data = this.value instanceof Array ? this.value : [this.value];
            }
        },
        data() {
            return {
                isEditing: false,
                loading: false,
                model: this.value,
                search: null,
                data: [],
                cached: []
            }
        },
        watch: {
            search(val) {
                this.loading = true;
                const params = new URLSearchParams(this.initialSearchParams);
                params.append("search", val);
                this.axios.get(this.url, {params})
                    .then(res => {
                        const {data} = res.data.data;
                        this.data = data.map(item => ({
                            text: item.name,
                            ...item
                        }));
                    })
                    .catch(err => console.log(err))
                    .finally(() => this.loading = false);
            },
            model(val) {
                this.$emit("input", val);
            },
            value(val) {
                this.model = val;
                if (!val) {
                    return;
                }
                this.data = [...this.data, ...(this.multi ? val : [val])];
            }
        },
        methods: {
            remove(id) {
                this.model = this.model.filter(item => item !== id);
            }
        }
    }
</script>

<style scoped>

</style>